export default {
  "home.heading.default": "join een call",
  "home.heading.loading": "Room openen...",
  "home.heading.join": "ready om te joinen?",
  "home.heading.joined": "je bent binnen",
  "home.heading.pending": "wachten op de host",
  "home.body.default": "maak een room, drop de link, vibe.",
  "home.body.loading": "sec, even de room fixen.",
  "home.body.join": "check je cam en mic, en jump erin.",
  "home.body.joined": "room is live. deel de link of let's go.",
  "home.body.joined_in_room": "in de room — jump erin of deel de link.",
  "home.body.pending": "de room is gelockt. de host laat je zo binnen.",
  "home.cta.create": "Maak room",
  "home.cta.join": "Join room",
  "home.cta.enter": "Enter room",
  "home.cta.creating": "Maken...",
  "home.cta.joining": "Joinen...",
  "home.cta.opening": "Openen...",
  "home.cta.pending": "Wachten op approval...",
  "home.copy_link": "kopieer link",
  "home.copied": "gekopieerd!",
  "home.leave": "leave room",
  "home.back": "terug",
  "home.no_participants": "nog niemand hier",
  "home.join_by_code": "join met invite code",
  "home.code_placeholder": "vul code in",
  "home.name_placeholder": "jouw naam",
  "home.people_one": "persoon",
  "home.people_other": "mensen",
  "home.marketing.invite.title": "Maak een room,\ndeel de link.",
  "home.marketing.invite.body": "Eén tap en je bent live. Deel de link met je vrienden en iedereen kan joinen — geen downloads, geen sign-ups.",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "Zie eruit\nzoals jij wilt.",
  "home.marketing.look.body": "Color grading, softening, vignette — of blur je gezicht helemaal. Jouw camera, jouw look.",
  "home.marketing.host.title": "Jouw space,\njouw regels.",
  "home.marketing.host.body": "Lock de room, mute iemand, of kick ze eruit. De host houdt de controle.",
  "home.marketing.host.locked": "Room gelockt",
  "home.marketing.host.waiting_to_join": "Wachten om te joinen",
  "home.marketing.host.wants_to_join": "wil joinen",
  "home.marketing.anything.title": "Echt voor alles.",
  "home.marketing.anything.body": "Study sessies, game nights, work standups, samen dingen kijken — of gewoon chillen.",
  "home.marketing.use_case.study_group": "📚 study group",
  "home.marketing.use_case.game_night": "🎮 game night",
  "home.marketing.use_case.standup": "💼 standup",
  "home.marketing.use_case.watch_party": "🍿 watch party",
  "home.marketing.use_case.catch_up": "☕ catch up",
  "home.marketing.use_case.jam_session": "🎸 jam sessie",
  "home.marketing.use_case.book_club": "📖 boekenclub",
  "home.marketing.use_case.coworking": "💻 co-working",
  "ended.heading": "call voorbij",
  "ended.left": "je bent geleaved.",
  "ended.room_ended": "{title} is voorbij voor jou.",
  "ended.rejoin": "rejoin",
  "ended.rejoining": "rejoinen...",
  "ended.home": "terug naar home",
  "call.connecting": "verbinden",
  "call.waiting": "wachten op de rest",
  "call.invite_code": "invite code",
  "call.audio_on": "audio aan",
  "call.muted": "gemute",
  "call.listening": "Luistert",
  "call.audio_muted": "Audio gemute",
  "call.speaking": "praat",
  "call.you": "jij",
  "call.you_label": "Jij",
  "call.you_suffix": "(jij)",
  "call.chat_placeholder": "stuur een berichtje...",
  "call.guest": "gast",
  "call.room_fallback": "room",
  "call.focus_view": "Focus view",
  "call.grid_view": "Grid view",
  "call.swap_main_video": "Wissel main video",
  "call.open_chat": "Open chat",
  "call.close_chat": "Sluit chat",
  "call.leave_room": "Leave room",
  "call.confirm_leave": "Leaven?",
  "call.mic_on": "Mic aan",
  "call.muted_label": "Gemute",
  "call.camera_off": "Camera uit",
  "call.connect_failed": "Verbinding mislukt — check je internet en probeer het nog eens.",
  "call.camera_access_failed": "Kon niet bij je camera. Check je browser permissies en probeer opnieuw.",
  "call.recording_failed": "Opnemen is mislukt. De call gaat verder zonder opname.",
  "call.initialize_failed": "Er ging iets mis met het starten van de call. Refresh even en probeer opnieuw.",
  "call.participants": "Deelnemers",
  "call.open_participants": "Open deelnemers",
  "call.close_participants": "Sluit deelnemers",
  "call.lock_room": "Lock room",
  "call.unlock_room": "Unlock room",
  "call.locked": "gelockt",
  "call.unlocked": "open",
  "call.kick_member": "Kick uit de room",
  "call.mute_member": "Mute",
  "call.unmute_member": "Unmute",
  "call.muted_by_host": "Gemute door de host",
  "call.waiting_to_join": "Wacht om te joinen",
  "call.approve": "Approve",
  "call.deny": "Deny",
  "call.profile_actions": "Profiel acties",
  "call.profile_in_room": "In de room",
  "call.profile_role_host": "Host",
  "call.profile_role_you": "Jij",
  "call.profile_action_mute": "Mute hun audio",
  "call.profile_action_mute_meta": "Alleen voor jou — ze merken er niks van",
  "call.profile_action_dm": "1:1 DM",
  "call.profile_action_dm_meta": "Start een privé chat",
  "call.profile_action_view": "Bekijk heel profiel",
  "call.profile_action_view_meta": "Bio, talen, eerdere sessies",
  "call.profile_action_report": "Report",
  "call.profile_action_report_meta": "Rapporteer voor moderatie",
  "call.profile_sheet_close": "Sluit profiel acties",
  "call.profile_open_actions": "Open profiel acties",
  "call.dm_title": "Direct message",
  "call.dm_back": "Terug naar acties",
  "call.dm_close": "Sluit direct message",
  "call.dm_status_online": "Online",
  "call.dm_in_room_with": "In deze room",
  "call.dm_private_label": "Privé chat",
  "call.dm_private_meta": "Alleen jullie twee kunnen deze messages zien",
  "call.dm_input_placeholder": "Stuur een privé berichtje…",
  "call.dm_send": "Stuur",
  "call.dm_just_now": "nu",
  "call.dm_seen_just_now": "Net gezien",
  "call.dm_typing": "{name} is aan het typen…",
  "call.dm_minimize": "Minimaliseer",
  "call.dm_active_indicator": "Open gesprek",
  "call.dm_unread_messages": "{count} ongelezen",
  "call.dm_toast_tap_to_open": "Tap om te openen",
  "call.dm_reopen_aria": "Heropen gesprek met {name}",
  "home.join_denied": "De host liet je niet binnen.",
  "home.error.room_not_found": "Die room code bestaat niet.",
  "home.error.profile_required": "Stel je profiel in om door te gaan.",
  "home.cta.set_up_profile": "Stel je profiel in",
  "home.profile_trigger_new": "Tap om je info toe te voegen",
  "home.profile_trigger_new_aria": "Stel je profiel in",
  "home.profile_trigger_edit_aria": "Edit je profiel",
  "profile.eyebrow_new": "say hi",
  "profile.eyebrow_edit": "jouw profiel",
  "profile.title_new": "Maak het van jou.",
  "profile.title_edit": "Edit profiel",
  "profile.subtitle": "Even wat snelle info zodat mensen weten met wie ze meeten.",
  "profile.add_photo": "Voeg foto toe",
  "profile.add_photo_soon": "foto's komen eraan",
  "profile.photo_empty": "tap om een foto toe te voegen",
  "profile.photo_ready": "foto ready",
  "profile.photo_save_first": "save je profiel voordat je een foto uploadt",
  "profile.photo_crop_caption": "frame je foto",
  "profile.photo_auto_caption": "drag en zoom, we saven het automatisch",
  "profile.photo_upload": "Upload foto",
  "profile.photo_replace": "Vervang foto",
  "profile.photo_remove": "Verwijder foto",
  "profile.photo_cancel": "Cancel",
  "profile.photo_save": "Save foto",
  "profile.photo_uploading": "Foto uploaden…",
  "profile.photo_removing": "Foto verwijderen…",
  "profile.photo_choose_another": "Kies een andere",
  "profile.photo_drag_hint": "Sleep de foto in de cirkel. Veranderingen worden automatisch gesaved.",
  "profile.photo_zoom": "Zoom",
  "profile.photo_horizontal": "Horizontaal croppen",
  "profile.photo_vertical": "Verticaal croppen",
  "profile.name_label": "Naam",
  "profile.name_placeholder": "Hoe mogen we je noemen?",
  "profile.gender_label": "Ik ben",
  "profile.gender.woman": "Vrouw",
  "profile.gender.man": "Man",
  "profile.gender.unspecified": "Zeg ik liever niet",
  "profile.bio_label": "Bio",
  "profile.bio_optional": "optioneel",
  "profile.bio_placeholder": "Talen die je spreekt, wat je leuk vindt, alles mag…",
  "profile.cta_new": "Let’s go",
  "profile.cta_edit": "Save changes",
  "profile.saving": "Saven…",
  "profile.close": "Sluiten",
  "profile.error.save_failed": "Kon je profiel niet saven. Probeer het nog eens.",
  "profile.error.avatar_invalid_type": "Kies een PNG, JPEG, GIF of WebP image.",
  "profile.error.avatar_too_large": "Kies een image kleiner dan 5 MB.",
  "profile.error.avatar_too_small": "Kies een image van minimaal 96 bij 96 pixels.",
  "profile.error.avatar_load_failed": "We konden die image niet lezen. Probeer een andere file.",
  "profile.error.avatar_failed": "Kon je foto niet uploaden. Probeer het nog eens.",
  "profile.error.avatar_remove_failed": "Kon je foto niet verwijderen. Probeer het nog eens.",
  "effects.title": "Effecten",
  "effects.soft": "Soft focus",
  "effects.vignette": "Vignette",
  "effects.face": "Face blur",
  "effects.face_preview_only": "Face blur (alleen preview)",
  "effects.face_viewer_side": "Face blur (viewer-kant)",
  "effects.face_strength": "Face blur sterkte",
  "effects.grade.off": "UIT",
  "effects.grade.pop": "POP",
  "effects.grade.warm": "WARM",
  "effects.grade.cool": "COOL",
  "effects.grade.bw": "Z&W",
  "camera.off": "camera is uit",
  "camera.check": "check je camera",
  "camera.retry": "probeer camera opnieuw",
  "camera.ready": "camera ready",
  "camera.idle.title": "Zet je camera aan",
  "camera.idle.hint": "We vragen je browser om toegang als je er klaar voor bent.",
  "camera.idle.button": "Zet camera aan",
  "camera.status.idle": "Wachten op jou",
  "camera.status.off": "Camera is uit",
  "camera.status.loading": "Camera toegang vragen...",
  "camera.status.denied": "Geef camera toegang in je browser en probeer het nog eens.",
  "camera.status.error": "Camera preview mislukt. Probeer het nog eens.",
  "camera.status.unsupported": "Deze browser ondersteunt geen camera toegang.",
  "camera.status.insecure": "Camera toegang heeft HTTPS of localhost nodig.",
  "camera.status.attach_failed": "Camera preview kon niet starten. Probeer het nog eens.",
  "camera.guest_name_placeholder": "Gast naam",
  "camera.flip": "Wissel camera",
  "camera.save_name": "Save",
  "camera.edit_name": "Edit naam",
  "mic.on": "Zet microfoon uit",
  "mic.off": "Zet microfoon aan",
  "video.on": "Zet camera uit",
  "video.off": "Zet camera aan",
  "chat.title": "chat",
  "chat.close": "Sluit chat",
  "chat.loading": "laden...",
  "chat.load_earlier": "laad oudere",
  "chat.empty": "nog geen berichtjes",
  "chat.send_error": "Berichtje niet verstuurd — probeer het nog eens.",
  "chat.input_placeholder": "typ een berichtje...",
  "room.host": "Host",
  "app.room_default_title": "Maak een room",
  "app.chat_connection_rejected": "Chat kon niet verbinden — probeer te refreshen.",
  "app.copy_failed": "Kon de link niet kopiëren. Selecteer 'm en kopieer handmatig.",
  "app.chat_not_connected": "Chat is nog niet verbonden. Wacht heel even en probeer het nog eens.",
  "footer.terms": "Voorwaarden",
  "footer.copyright": "© 2026 Yano.AI"
}
